// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {CircularProgress, Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {useHistory} from 'react-router-dom';
import {useState} from 'react';
import {useEffect} from 'react';
import type {Store, Country, PaymentProvider} from '../../../../entities';
import {connect} from 'react-redux';
import type {RootState} from '../../..';
import type {Dispatch} from 'redux';
import {bindActionCreators} from 'redux';
import {actions as CheckoutActions} from '../../duck';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';
import {useForm} from 'react-hook-form';
import {useMemo} from 'react';
import {getConfigurationAdmin} from '../../../../utils/location';
import type {ConfigurationAdmin} from '../../../../utils/location/api';
import type {SaveCardRequest} from '../../api';
import type {StripeInitialization} from '../../duck';
import StripeCheckoutForm from '../Stripe/StripeCheckoutForm';
import type {TierDetail} from '../../../tiers/api';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    stripeInitialization: state.checkout.stripeInitialization,
    isInitializing: state.checkout.isInitializing,
    planSelected: state.tiersList.planSelected,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
      },
      dispatch
    )
)(AddCardModal);

type Props = {
  store?: Store,
  open?: boolean,
  handleClose: () => void,
  country?: Country,
  paymentProvider: PaymentProvider,
  stripeAddCardInitialize: ({subscribeRequest: SaveCardRequest}) => void,
  stripeInitialization?: StripeInitialization,
  isInitializing?: boolean,
  planSelected?: TierDetail,
  resetStripeInitialization: () => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 500,
    maxWidth: '100%',
    // padding: theme.spacing(5, 0),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(2),
  },
  text: {
    marginTop: theme.spacing(3),
    color: colors.grey800,
    fontSize: '1.125rem',
  },
  button: {
    height: 48,
    // borderRadius: '8px',
    marginTop: theme.spacing(3),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 36px',
  },
  secondButton: {
    marginTop: theme.spacing(1),
  },
}));

function AddCardModal(props: Props) {
  const {
    store,
    open,
    handleClose,
    country,
    paymentProvider,
    stripeAddCardInitialize,
    stripeInitialization,
    isInitializing,
    planSelected,
    resetStripeInitialization,
  } = props;

  const classes = useStyles();

  const history = useHistory();

  const {register, handleSubmit, errors, reset} = useForm({
    mode: 'onChange',
    shouldUnregister: false,
  });

  const countryCode = country ? country.code : 'PE';
  const configAdmin: ConfigurationAdmin = getConfigurationAdmin(countryCode);

  const [isSavingCard, setIsSavingCard] = useState(false);

  const disableInput = useMemo(() => {
    return !!isSavingCard;
  }, [isSavingCard]);

  const [step, setStep] = useState(0);

  const onSubmit = values => {
    const subscribeRequest: SaveCardRequest = {
      billingAddress: {
        firstName: values.firstName,
        lastName: values.lastName,
        idNumber: values.idNumber,
        // email: data.email,
        // razonSocial:data.razonSocial,
        // ruc:data.ruc,
        address1: values.address,
        country: country ? country.code : 'PE',
        admin1: values.admin1 || undefined,
        admin2: values.admin2 || undefined,
        admin3: values.admin3 || undefined,
      },
      paymentProviderId: paymentProvider ? paymentProvider.id : undefined,
    };
    // console.log(subscribeRequest);
    stripeAddCardInitialize({subscribeRequest});
  };

  useEffect(() => {
    if (stripeInitialization && stripeInitialization.clientSecret) {
      setStep(1);
    }
  }, [history, stripeInitialization]);

  const handleCloseModal = () => {
    setStep(0);
    resetStripeInitialization();
    handleClose();
    reset();
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Agregar Método de Pago
        </Typography>
        {step === 0 ? (
          <>
            <CustomTextField
              label="Nombres"
              name="firstName"
              className={classes.textField}
              // defaultValue={''}
              error={!!errors.firstName}
              helperText={errors.firstName ? errors.firstName.message : ''}
              inputRef={register({
                required: 'Campo obligatorio',
              })}
              type="text"
              disabled={disableInput}
            />
            <CustomTextField
              label="Apellidos"
              name="lastName"
              className={classes.textField}
              // defaultValue={''}
              error={!!errors.lastName}
              helperText={errors.lastName ? errors.lastName.message : ''}
              inputRef={register({
                required: 'Campo obligatorio',
              })}
              type="text"
              disabled={disableInput}
            />

            <CustomTextField
              label="Documento de identidad"
              name="idNumber"
              className={classes.textField}
              // defaultValue={''}
              error={!!errors.idNumber}
              helperText={errors.idNumber ? errors.idNumber.message : ''}
              inputRef={register({
                // required:
                //   tipoComprobante === 'BOLETA' ? 'Campo obligatorio' : false,
                // pattern: {
                //   value: /^[0-9]{8}$/i,
                //   message: 'Formato de DNI inválido',
                // },
              })}
              type="text"
              disabled={disableInput}
            />

            {/* <CustomTextField
        label="Número telefónico"
        name="phone"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.phone}
        helperText={errors.phone ? errors.phone.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
          pattern: {
            value: /^[0-9]{7,12}$/i,
            message: 'Formato de teléfono inválido',
          },
        })}
        type="text"
        disabled={disableInput}
      /> */}
            {/* <CustomTextField
        label="Correo electrónico"
        name="email"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Formato de email inválido',
          },
        })}
        type="text"
        disabled={disableInput}
      /> */}
            <CustomTextField
              label="Dirección"
              name="address"
              className={classes.textField}
              error={!!errors.address}
              helperText={errors.address ? errors.address.message : ''}
              inputRef={register({
                required: 'Campo obligatorio',
              })}
              type="text"
              disabled={disableInput}
            />
            {configAdmin.admin1.enabled && (
              <CustomTextField
                label={configAdmin.admin1.label}
                name="admin1"
                className={classes.textField}
                error={!!errors.admin1}
                helperText={errors.admin1 ? errors.admin1.message : ''}
                inputRef={register({
                  required: 'Campo obligatorio',
                })}
                type="text"
                disabled={disableInput}
              />
            )}
            {configAdmin.admin2.enabled && (
              <CustomTextField
                label={configAdmin.admin2.label}
                name="admin2"
                className={classes.textField}
                error={!!errors.admin2}
                helperText={errors.admin2 ? errors.admin2.message : ''}
                inputRef={register({
                  required: 'Campo obligatorio',
                })}
                type="text"
                disabled={disableInput}
              />
            )}
            {configAdmin.admin3.enabled && (
              <CustomTextField
                label={configAdmin.admin3.label}
                name="admin3"
                className={classes.textField}
                error={!!errors.admin3}
                helperText={errors.admin3 ? errors.admin3.message : ''}
                inputRef={register({
                  required: 'Campo obligatorio',
                })}
                type="text"
                disabled={disableInput}
              />
            )}
            <CustomButton
              variant="contained"
              className={classes.button}
              onClick={handleSubmit(onSubmit)}
              // disabled={disabled}
            >
              Continuar
            </CustomButton>
          </>
        ) : isInitializing ? (
          <CircularProgress className={classes.loading} />
        ) : (
          <>
            <br />
            {!!paymentProvider && !!store && paymentProvider.name === 'STRIPE' && (
              <>
                <StripeCheckoutForm
                  paymentProvider={paymentProvider}
                  setIsPaying={setIsSavingCard}
                  disabled={disableInput}
                  type="save_card"
                />
              </>
            )}
            <CustomButton
              variant="contained"
              className={classes.button}
              form="payment-form"
              type="submit"
              disabled={isSavingCard}
            >
              {isSavingCard ? (
                <CircularProgress size={30} style={{alignSelf: 'center'}} />
              ) : planSelected ? (
                'Guardar y actualizar subscripción'
              ) : (
                'Guardar método de pago'
              )}
            </CustomButton>
          </>
        )}
      </div>
    </CustomModal>
  );
}

AddCardModal.propTypes = {
  store: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  country: PropTypes.object,
  paymentProvider: PropTypes.object,
  stripeAddCardInitialize: PropTypes.func,
  stripeInitialization: PropTypes.object,
  isInitializing: PropTypes.bool,
  planSelected: PropTypes.object,
  resetStripeInitialization: PropTypes.func.isRequired,
};
